import { render } from "./year-charts.vue?vue&type=template&id=e9c273ae"
import script from "./year-charts.vue?vue&type=script&lang=ts"
export * from "./year-charts.vue?vue&type=script&lang=ts"
script.render = render

export default script